let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理'
    },
    {
        type: 'title',
        name: '活动订单列表'
    },
    {
        type: 'title',
        name: '总商品订单列表'
    }
];

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

export default pageConfig;
